var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup23X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7335 6.04951H0V0H24.7335V6.04951ZM0.569633 5.47987H24.1638V0.569633H0.569633V5.47987Z",
    fill: "#233A80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9281 14.0246H0V7.9751H11.9281V14.0246ZM0.569633 13.455H11.3585V8.54473H0.569633V13.455Z",
    fill: "#233A80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4194 22.0001H0V15.9392H17.4194V22.0001ZM0.569633 21.4305H16.8498V16.5088H0.569633V21.4305Z",
    fill: "#233A80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 5.5V0.5H24.5V5.5H0.5Z",
    fill: "#233A80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14V8H12V14H0Z",
    fill: "#233A80"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 22V16H17V22H0Z",
    fill: "#233A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup23X);
export default __webpack_public_path__ + "static/media/Group23x.d79fff78cb01e64f79ca8186d71f56a0.svg";
export { ForwardRef as ReactComponent };